import path from 'ramda/src/path'
import values from 'ramda/src/values'
import { MODIFY_DROP_DELIVERED_REWARD } from 'root/src/shared/descriptions/endpoints/endpointIds'
import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'

export default (moduleRecordType, properties) => async (dispatch, getState) => {
	const records = values(path(['api', 'records', moduleRecordType], getState()))
	await invokeApiRequest(MODIFY_DROP_DELIVERED_REWARD, { records, properties }, getState())
}
